import { TranslationSchema } from '@skop-app/lib-domain/types'

export interface Point {
  x: number
  y: number
}

export interface Section {
  id: string
  name: string
  type: string
  blueprintUrl?: string
  sectionSubSectionsId?: string
  translations?: {
    items: TranslationSchema[]
  }
}

export enum ShapeType {
  LINE = 'LINE',
  RECTANGLE = 'RECTANGLE',
  FREEFORM = 'FREEFORM',
  MARKER = 'MARKER',
  MEASURE = 'MEASURE',
  POINT = 'POINT',
  TEXT = 'TEXT',
}

export type DrawingMode = ShapeType | 'move' | 'edit' | 'scale'

interface BaseShape {
  id: string
  type: Omit<DrawingMode, ShapeType.MARKER | ShapeType.MEASURE>
  points: Point[]
  name: string
  color: string
  blueprintShapesId: string // parent blueprint
  sectionShapesId: string // parent section
  parentShapesId?: string // parent shape
  area?: number
  comment?: string
  imageUrl?: string
  length?: number
  sectionType?: 'zone' | 'room'
}
export interface MarkerShape extends BaseShape {
  type: ShapeType.MARKER
  markerId: string
  rotation?: number
}

export interface ProductShape extends MarkerShape {
  shapeProductId: string
}

export interface MeasureShape extends BaseShape {
  type: ShapeType.MEASURE
  markerId: 'product'
  length: number
}

export type Shape = BaseShape | MarkerShape | MeasureShape | ProductShape

export interface Transform {
  scale: number
  x: number
  y: number
}

export type TreeNode =
  | (Section & {
      treeLevel: 'section'
      children?: TreeNode[]
      parentId?: string
    })
  | (Shape & {
      treeLevel: 'shape'
      children?: TreeNode[]
      parentId?: string
    })

export type BlueprintResponse = {
  getBlueprint: Blueprint
}

export type BlueprintInput = {
  id: string
  name: string
  projectBlueprintsId: string
  imageUrl?: string
}

export type SectionInput = {
  id: string
  name: string
  type: string
  blueprintSectionsId: string
  sectionSubSectionsId?: string
  blueprintUrl?: string
}

export type SectionSchema = SectionInput & {
  shapes: {
    items: Shape[]
  }
  translations?: {
    items: TranslationSchema[]
  }
}

export type Blueprint = BlueprintInput & {
  project: {
    id: string
    name: string
  }
  sections: {
    items: SectionSchema[]
  }
}
